/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import { Icons } from '@myob/myob-widgets';
import { BreadcrumbWrapper } from './styles';
import * as telemetry from '../../telemetry';
import { ETelemetryActionsAndLabels, ETelemetryNames } from '../../telemetry/type';
import upperFirst from 'lodash/upperFirst';

export type BreadcrumbsProps = {
    parentPathname: string;
    parentPageName: string;
    currentPageName: string;
    telemetryEventName: ETelemetryNames;
};
export const Breadcrumbs: React.FC<BreadcrumbsProps> = ({
    parentPageName,
    parentPathname,
    currentPageName,
    telemetryEventName,
}) => {
    const onClickBreadcrumbs = (pathName: string) => {
        telemetry.track(telemetryEventName, {
            action: ETelemetryActionsAndLabels.Click,
            label: ETelemetryActionsAndLabels.Click,
            clickData: {
                buttonName: upperFirst(pathName),
            },
        });
    };
    return (
        <BreadcrumbWrapper>
            <a href={parentPathname} onClick={() => onClickBreadcrumbs(parentPathname)} rel="noopener noreferrer">
                {parentPageName}
            </a>
            <span className="icon">
                <Icons.RightChevron size="12px" />
            </span>
            <span>{currentPageName}</span>
        </BreadcrumbWrapper>
    );
};
